/*       */

import { gql } from '@apollo/client';

export default gql`
    query processesDefinitionsTypeaheadQuery($orderBy: [JSON]) {
        records: processDefinitions(orderBy: $orderBy) {
            id
            name
            primary(fields: ["definition"])
        }
    }
`;
